export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {
    XMarkdownPlugin,
    XMarkdownRenderTreeNode,
} from 'kpc';

interface Props {
    content: string
}

const CONTENT = `# 插件扩展示例

> 这段提示块没有额外写 HTML，而是由 \`extendMarkdown\` 在 token 阶段给引用块补上样式类名。

## 发布建议

- 先把基础渲染能力稳定下来
- 再补正式扩展口子和示例
- 最后完善测试和文档

## 实现边界

\`transformRenderTree\` 更适合做结构层加工，例如统一给标题补徽标、包装节点或插入额外提示。`;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: CONTENT,
        };
    }

    getPlugin(): XMarkdownPlugin {
        return {
            extendMarkdown: (markdown: any) => {
                markdown.core.ruler.push('xmarkdown-demo-tip', (state: any) => {
                    state.tokens.forEach((token: any) => {
                        if (token.type === 'blockquote_open') {
                            token.attrJoin('class', 'xmarkdown-demo-plugin-tip');
                        }
                    });
                });
            },
            transformRenderTree: (nodes) => this.appendHeadingBadge(nodes),
        };
    }

    appendHeadingBadge(nodes: XMarkdownRenderTreeNode[]): XMarkdownRenderTreeNode[] {
        return nodes.map((node) => {
            if (node.type !== 'element') return node;

            const nextNode = {
                ...node,
                children: this.appendHeadingBadge(node.children),
            };

            if (nextNode.tag !== 'h2') return nextNode;

            return {
                ...nextNode,
                children: [
                    ...nextNode.children,
                    this.createBadgeNode('插件已处理'),
                ],
            };
        });
    }

    createBadgeNode(text: string): XMarkdownRenderTreeNode {
        return {
            type: 'element',
            tag: 'span',
            attrs: {
                className: 'xmarkdown-demo-plugin-badge',
            },
            children: [
                {
                    type: 'text',
                    content: text,
                },
            ],
        };
    }
}